import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

import conf from '../../../../conf.js';
import {isAdmin} from '../../../../../shared/services/userService.js';

class Email extends PureComponent {
  render() {
    const {currentUser, user, ...props} = this.props;

    if (props.isAdmin && user) {
      return <a
        href={`mailto:${user?.email ?? ''}`}
        className="data"
      >
        {user?.email ?? 'Pas de mail'}
      </a>;
    }

    return <a
      className="data"
      href={`mailto:${conf.site.emails.contact}?
              subject=${currentUser?.fullname ?? ''} de ${currentUser?.organisation.name ?? ''} demande à rencontrer ${user?.fullname ?? ''}
              &body=Je souhaite rencontrer ${user?.fullname ?? ''} + ${user?.id ?? ''} au plus vite.%0D%0AMerci de me recontacter à cet effet au ${currentUser?.tel ?? ''} ou à ${currentUser?.email ?? ''}%0D%0APréférablement entre 9 et 18h.%0D%0A%0D%0ACordialement,%0D%0A%0D%0A${currentUser?.fullname ?? ''} + ${currentUser?.id ?? ''}`}
    >{conf.site.emails.contact}</a>;
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(Email);